import { urlService } from '@/shared/services/UrlService';
import { AxiosResponse, default as axios } from 'axios';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { IAggregateResultItemHypermediaRepresentation } from '../shared/contracts/AggregateContract';
import { IRootHypermediaRepresentation } from '../shared/contracts/RootContract';
import { IGroupDetailsState, IRootState } from './contract';

const state: IGroupDetailsState = {
    aggregate: undefined
};

const mutations: MutationTree<IGroupDetailsState> = {
    aggregateLoaded(rootState, payload: IAggregateResultItemHypermediaRepresentation) {
        rootState.aggregate = payload;
    }
};

const actions: ActionTree<IGroupDetailsState, IRootState> = {
    async fetchHiveAggregate({ commit, rootState }, hiveId: string): Promise<void> {
        let url = urlService.replaceURIPlaceholders(
            (rootState.root as IRootHypermediaRepresentation)._links.aggregate_hive.href,
            { hiveId }
        );
        let response: AxiosResponse<IAggregateResultItemHypermediaRepresentation> = await axios.get(url);
        commit('aggregateLoaded', response && response.data);
    },
    async fetchTribeAggregate({ commit, rootState }, tribeId: string): Promise<void> {
        let url = urlService.replaceURIPlaceholders(
            (rootState.root as IRootHypermediaRepresentation)._links.aggregate_tribe.href,
            { tribeId }
        );
        let response: AxiosResponse<IAggregateResultItemHypermediaRepresentation> = await axios.get(url);
        commit('aggregateLoaded', response && response.data);
    },
    async fetchSectorAggregate({ commit, rootState }, sectorId: number): Promise<void> {
        let url = urlService.replaceURIPlaceholders(
            (rootState.root as IRootHypermediaRepresentation)._links.aggregate_sector.href,
            { sectorId }
        );
        let response: AxiosResponse<IAggregateResultItemHypermediaRepresentation> = await axios.get(url);
        commit('aggregateLoaded', response && response.data);
    },
    async fetchAccountAggregate({ commit, rootState }, accountId: number): Promise<void> {
        let url = urlService.replaceURIPlaceholders(
            (rootState.root as IRootHypermediaRepresentation)._links.aggregate_account.href,
            { accountId }
        );
        let response: AxiosResponse<IAggregateResultItemHypermediaRepresentation> = await axios.get(url);
        commit('aggregateLoaded', response && response.data);
    }
};

const getters: GetterTree<IGroupDetailsState, IRootState> = {};

const namespaced: boolean = true;

export const details: Module<IGroupDetailsState, IRootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
